import React from 'react';

import Marker from './styles';

export default function MarkerLetter({ letter, background, color, onClick, sizeIcon = 22 }) {
  return (
    <Marker
      $letter={letter}
      $background={background}
      $color={color}
      onClick={onClick}
      $sizeIcon={sizeIcon}
    />
  );
}
